import { getInboxItemDisplay } from './notificationInbox';
import { navigateToCampaign } from './navigationBridge';

let prefEnabled = true;

export function setDesktopNotificationsPref(enabled) {
  prefEnabled = enabled !== false;
}

export function getDesktopNotificationsPref() {
  return prefEnabled;
}

export function isElectronDesktop() {
  return Boolean(typeof window !== 'undefined' && window.electronAPI?.isElectron);
}

/**
 * First snapshot never toasts (opening the app must not replay the inbox).
 * After that, only unread rows we have not seen.
 */
export function collectNewInboxToasts(prevIds, items) {
  const list = Array.isArray(items) ? items : [];
  const nextIds = new Set(list.map((item) => item?.id).filter(Boolean));
  if (prevIds == null) return { nextIds, toasts: [] };
  const toasts = list.filter(
    (item) => item?.id && !item.read && !item.targetGone && !prevIds.has(item.id)
  );
  return { nextIds, toasts };
}

export function formatInboxToast(item) {
  const display = getInboxItemDisplay(item);
  return {
    title: `${display.prefix} ${display.mission}`.trim(),
    message: [display.note, display.path].filter(Boolean).join('\n'),
  };
}

export function desktopToastPayload(item) {
  const toast = formatInboxToast(item);
  return {
    id: item.id,
    title: toast.title,
    body: toast.message,
    campaignId: item.campaignId || null,
    missionId: item.missionId || null,
    targetGone: Boolean(item.targetGone),
    targetGoneKind: item.targetGoneKind || null,
  };
}

export async function shouldShowDesktopToast() {
  if (!getDesktopNotificationsPref() || !isElectronDesktop()) return false;
  if (typeof window.electronAPI.notify?.isWindowFocused !== 'function') return false;
  try {
    const focused = await window.electronAPI.notify.isWindowFocused();
    return !focused;
  } catch {
    return false;
  }
}

export async function showDesktopToast(item) {
  if (!(await shouldShowDesktopToast())) return false;
  if (typeof window.electronAPI.notify?.show !== 'function') return false;
  try {
    await window.electronAPI.notify.show(desktopToastPayload(item));
    return true;
  } catch {
    return false;
  }
}

export function openInboxTarget(payload) {
  if (!payload?.campaignId) return false;
  return navigateToCampaign(
    { id: payload.campaignId },
    payload.missionId ? { missionId: payload.missionId } : {}
  );
}
